export default __webpack_public_path__ + "static/media/dyeing10.2ce9c260.png";